module.exports = __webpack_public_path__ + "img/logo4.d0505a6e.png";